import { Pipe, PipeTransform } from '@angular/core';

import { Role } from '@data';

@Pipe({
  name: 'roleName',
})
export class RoleNamePipe implements PipeTransform {
  transform(role: Role): string {
    return role.replace('MFG_', '').replace('_', ' ');
  }
}
